module.exports = __webpack_public_path__ + "static/media/newageislam-dummy.d426b7b8.jpg";